import { Component, OnInit } from '@angular/core';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { NavigationInputComponent } from './navigation-input/navigation-input.component';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { EditorService } from '../services/editor.service';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';

@Component({
  selector: 'ngx-navigation-editor',
  templateUrl: './navigation-editor.component.html',
  styleUrls: ['./navigation-editor.component.scss']
})
export class NavigationEditorComponent implements OnInit{
  inputComponent = new DynamicInputComponent(NavigationInputComponent);
  title = "Editing Navigation";
  menuTag = "editNavigationMenu";
  menuGroups:any;
  menuGroup:MenuGroup = {
    title:"Edit Site Navigation",
    menuTag:"editNavigationMenu",
    menuItems: [
      {
        title:"Main Menu"
      },
      {
        title:"User Menu"
      },
      {
        title:"Footer Links"
      },
      {
        title:'Add Section',
        children:[
          {
            title:'Grid',
            children:[
              {
                title:'Add New Grid'
              },
              {
                title:'Edit Existing Grid'
              }
            ]
          },
          {
            title:'Banner'
          },
          {
            title:'Slider'
          },
          {
            title:'Slide Show'
          }
        ]
      },
      {
        title:'Remove Section',
      },
      {
        title:'Order Sections',
      },
    ]
  }
  menuItems:NbMenuItem[] = [
    {
      title:"Main Menu"
    },
    {
      title:"User Menu"
    },
    {
      title:"Footer Links"
    } 
  ]
  previousMenu:NbMenuItem[] = [];

  constructor(private editorService:EditorService,
    private menuService:NbMenuService){}
  
  ngOnInit(): void {
    this.menuGroups = this.editorService.createMenusFromGroup(this.menuGroup);
    this.inputComponent.data = this.menuGroups;
    this.editorService.setInputComponent(this.inputComponent);
    console.log(this.menuGroups);
    

  }
}
